export default "__VITE_ASSET__4d229876__"